var finansudd = finansudd || {};

finansudd.favorites = new function () {

	var self = this;
	
	this.init = function () {
		self.favoritesSet();
		self.favoritesRemove();
	    self.setFavoritesOnlist();
	};

	this.favoritesSet = function () {

		$('body').on('click', '.item-favorite', function (e) {
			e.stopPropagation();
			e.preventDefault();

            //Animate Star
		    $(this).addClass('animate-star');

			var favoriteId = $(this).data('nodeid');
			var favoritList = localStorage.favorites;

			//Call Indicator
			finansudd.toolbar.animateIcon('.favorites .icon'); 

			self.favoritesSetIndicator(favoriteId, favoritList);
			self.updateFavorites(favoriteId, favoritList);
		});
	};

	this.favoritesRemove = function () {

		$('body').on('click', '.favorite-remove', function (e) {
			e.stopPropagation();
			e.preventDefault();

			var favoriteId = $(this).data('nodeid');
			var favoritList = localStorage.favorites;

			//Call Indicator
			self.favoritesSetIndicator(favoriteId, favoritList);
			self.updateFavorites(favoriteId, favoritList);
			finansudd.courselist.loadFavorites(1, localStorage.favorites);
		});
	};

	this.isFavoriteInStorage = function (favoriteId, favoritList) {
	    //Check if localStorage is empty
	    if (favoritList == undefined) {
	        favoritList = "";
	    }

	    //Convert string to array
	    var favoriteArr = favoritList.split(',');
	    if (favoriteArr.length == 1 && favoriteArr[0] == "") {
	        favoriteArr = [];
	    }
	    //Check if ID is contained in array
	    return $.inArray(favoriteId + "", favoriteArr) !== -1;
	}

	this.updateFavorites = function (favoriteId, favoritList) {
		//Check if localStorage is empty
		if (favoritList == undefined) {
			favoritList = "";
		}

		//Convert string to array
		var favoriteArr = favoritList.split(',');
		if (favoriteArr.length == 1 && favoriteArr[0] == "") {
			favoriteArr = [];
		}
		//Check if ID is contained in array
		if (this.isFavoriteInStorage(favoriteId, favoritList)) {
			//Remove from list
			favoriteArr.splice($.inArray(favoriteId + "", favoriteArr), 1);
		}
		else {
			//Add to list list
			favoriteArr.push(favoriteId);
		}

		//Convert array to string and save in localStorage
		var newList = favoriteArr.join().toString();
		localStorage.favorites = newList;
	}

	this.setFavoritesOnlist = function () {
		if (localStorage.favorites != undefined && localStorage.favorites != "") {
			var arrFarvoritList = localStorage.favorites.split(',');
			for (var i = 0; i < arrFarvoritList.length; i++) {
			    if (arrFarvoritList[i].length) {
			        var item = $(".item-favorite[data-nodeid=" + arrFarvoritList[i] + "]");
                    if (item != null && item.length) {
                        item.addClass("is-favorite");
                    }
			    }
			}
		}
	}

	this.favoritesSetIndicator = function (favoriteId, favoriteList) {
	    var item = $(".item-favorite[data-nodeid=" + favoriteId + "]");
	    if (this.isFavoriteInStorage(favoriteId, favoriteList)) {
	        item.removeClass("is-favorite").removeClass('animate-star');
		}
		else {
	        item.addClass("is-favorite");
		}
	}

};